import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createExternalRelationInterest = (payload) => {
    return vdkEmHappinessPortalApi.post('/externalrelationsinterests/create', payload);
};
const updateExternalRelationInterest = (payload) => {
    return vdkEmHappinessPortalApi.put('/externalrelationsinterests/update', payload);
};
const deleteExternalRelationInterest = (id) => {
    return vdkEmHappinessPortalApi.delete(`/externalrelationsinterests/${id}`);
};
const getExternalRelationInterestById = (id) => {
    return vdkEmHappinessPortalApi.get(`/externalrelationinterests/${id}`);
};
const getExternalRelationInterestsByRelationId = (payload) => {
    return vdkEmHappinessPortalApi.post('/externalrelationinterests/get-all', payload);
};
const ExternalRelationInterestsApi = {
    createExternalRelationInterest,
    updateExternalRelationInterest,
    deleteExternalRelationInterest,
    getExternalRelationInterestById,
    getExternalRelationInterestsByRelationId
};
export default ExternalRelationInterestsApi;
